import "core-js/modules/es.array.for-each";
import "core-js/modules/es.object.to-string";
import "core-js/modules/es.regexp.to-string";
import "core-js/modules/web.dom-collections.for-each";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "D:/work/admin/datacenter_web/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { serchSelect } from "@/mixins/index";
import { dataSummary } from "@/api/dataAll/dataSummary";
import { getadvLocation } from "@/api/dataAll/advLocation";
import { getStaticData } from "@/api/dataAll/monStaric";
import addLinks from "./components/addLinks";
import clipboard from '@/utils/clipboard';
export default {
  name: "montorStarticData",
  components: {
    addLinks: addLinks
  },
  data: function data() {
    return {
      tableTitle: [],
      gameId: "",
      value1: "",
      value2: [],
      total: 0,
      pagrSize: 10,
      addWayConfig: false,
      searchData: {
        page: 1,
        game: "",
        platform: "",
        channel: "",
        pkg: "",
        starttime: "",
        endtime: "",
        advChannel: "",
        advLocation: ""
      },
      typeArr: [{
        id: "1",
        type_name: 'click'
      }, {
        id: "2",
        type_name: 'show'
      }, {
        id: "3",
        type_name: '不选'
      }],
      searchMark: {
        game: "",
        platform: "",
        channel: "",
        pkg: "",
        starttime: "",
        endtime: "",
        ad_channel: "",
        ad_placement: "",
        type: ""
      },
      tableData: [],
      tableLtv: [],
      tableDate: "",
      show: false,
      echarts: false,
      dates: [],
      new_device_num: [],
      new_account_num: [],
      active_account_num: [],
      day_account: [],
      recharge_account_num: [],
      recharge_account_amount: [],
      pay_account_percent: [],
      pay_account_arpu: [],
      pay_account_arppu: [],
      login_account_num: []
    };
  },
  created: function created() {
    var _this = this;

    this.getsearchDate();
    searchgame().then(function (res) {
      _this.searchgames = res.data;
      _this.gameId = res.data.id;
    }); // getCountry().then((res) => {
    //   this.searchpcountry = res.data;
    // });
  },
  methods: {
    getsearchDate: function getsearchDate() {
      var now = new Date(this.$times.zeroTimeZone());
      var year = now.getFullYear();
      var month = (now.getMonth() + 1).toString().length < 2 ? "0" + (now.getMonth() + 1) : now.getMonth() + 1;
      var date = now.getDate().toString().length < 2 ? "0" + now.getDate() : now.getDate();
      var date = year + "-" + month + "-" + date;
      this.value2[0] = date;
      this.value2[1] = date;
    },
    typechange: function typechange(id) {
      var _this2 = this;

      if (id != "") {
        this.typeArr.forEach(function (item) {
          if (item.id == id) {
            _this2.searchMark.type = item.type_name;
          }
        });
      } else {
        this.searchMark.type = "";
      }
    },
    searchClick: function searchClick() {
      var _this3 = this;

      if (this.value2.length > 0) {
        this.searchMark.starttime = this.value2[0];
        this.searchMark.endtime = this.value2[1];
      }

      this.reqLoading = true;
      getStaticData(this.searchMark).then(function (res) {
        if (res.status == 200) {
          _this3.tableData = res.data || [];
        }
      }).finally(function () {
        _this3.reqLoading = false;
      });
    },
    handleSource: function handleSource(id, num) {
      var _this4 = this;

      this.addWayConfig = true;
      this.$nextTick(function () {
        _this4.$refs.addWayConfig.init(id, num);
      });
    },
    handleClipboard: function handleClipboard(text, event) {
      clipboard(text, event);
    },
    handleCurrentChange: function handleCurrentChange(val) {
      this.searchMark.page = val;
      this.searchData.page = val;
      this.searchClick();
    },
    handleDelete: function handleDelete(id) {
      var _this5 = this;

      this.$confirm("此操作将删除该检测链接, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                deleLinksList({
                  id: id
                }).then(function (res) {
                  _this5.searchClick();
                });

                _this5.$message({
                  type: "success",
                  message: "删除成功!"
                });

              case 2:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      })));
    }
  }
};